<wuc-page-block
    class="insurance-list-relative"
    blockType="open"
    [icon]="productIconName"
    [isMobile]="isScreenSmall$ | async"
    id="{{ insuranceListId }}{{ purchasedProduct.productSequenceNumber }}"
>
    <div
        class="insurance-list-toggle insurance-list-toggle--small insurance-list-toggle--mobile"
        *ngIf="purchasedProduct.coverage"
    >
        <ins-insurance-list-link
            *ngIf="selectedPanel === selectedPanelEnum.Close"
            [productSequenceNumber]="purchasedProduct.productSequenceNumber"
            [productId]="purchasedProduct.productId"
            [openPanel]="selectedPanelEnum.InsuranceDetail"
            [selectedPanel]="selectedPanel"
        ></ins-insurance-list-link>
        <ins-insurance-list-link
            *ngIf="selectedPanel !== selectedPanelEnum.Close"
            [productSequenceNumber]="purchasedProduct.productSequenceNumber"
            [productId]="purchasedProduct.productId"
            [openPanel]="selectedPanelEnum.Close"
            [selectedPanel]="selectedPanel"
        ></ins-insurance-list-link>
    </div>
    <ng-container slot="header">
        <ins-insurance-list-title [purchasedProduct]="purchasedProduct"></ins-insurance-list-title>
        <ins-insurance-list-notice [purchasedProduct]="purchasedProduct"></ins-insurance-list-notice>
        <ins-insurance-list-related-vehicle [purchasedProduct]="purchasedProduct"></ins-insurance-list-related-vehicle>
    </ng-container>
    <wuc-rack>
        <wuc-rack columnsMobile="1" columnsTablet="2" columnsDesktop="2">
            <ins-insurance-list-coverages
                *ngIf="isCurrent"
                display="current"
                [purchasedProduct]="purchasedProduct"
            ></ins-insurance-list-coverages>
            <ins-insurance-list-coverages
                *ngIf="isFuture"
                display="future"
                [purchasedProduct]="purchasedProduct"
            ></ins-insurance-list-coverages>
            <ins-insurance-list-changes [purchasedProduct]="purchasedProduct"></ins-insurance-list-changes>
        </wuc-rack>
        <wuc-rack columnsMobile="1" columnsTablet="2" columnsDesktop="2">
            <div class="insurance-list-toggle--desktop">
                <ins-insurance-list-link
                    *ngIf="selectedPanel === selectedPanelEnum.Close"
                    [productSequenceNumber]="purchasedProduct.productSequenceNumber"
                    [productId]="purchasedProduct.productId"
                    [openPanel]="selectedPanelEnum.InsuranceDetail"
                    [selectedPanel]="selectedPanel"
                    title="Details"
                ></ins-insurance-list-link>
                <ins-insurance-list-link
                    *ngIf="selectedPanel !== selectedPanelEnum.Close"
                    [productSequenceNumber]="purchasedProduct.productSequenceNumber"
                    [productId]="purchasedProduct.productId"
                    [openPanel]="selectedPanelEnum.Close"
                    [selectedPanel]="selectedPanel"
                    title="Sluiten"
                ></ins-insurance-list-link>
            </div>
            <div class="insurance-list-buttons">
                <ins-direct-control-buttons
                    [purchasedProduct]="purchasedProduct"
                    e2e="direct-control-button"
                ></ins-direct-control-buttons>
                <ins-insurance-list-price [purchasedProduct]="purchasedProduct"></ins-insurance-list-price>
            </div>
        </wuc-rack>
        <wuc-balloon
            [id]="'product_' + purchasedProduct.productSequenceNumber + '_panel'"
            arrowPosition="topLeft"
            backgroundStyle="primary"
            padding="medium"
            *ngIf="isPanelOpen"
        >
            <ng-container [ngSwitch]="selectedPanel">
                <ins-insurance-detail
                    *ngSwitchCase="selectedPanelEnum.InsuranceDetail"
                    [purchasedProduct]="purchasedProduct"
                    [relation]="relation"
                ></ins-insurance-detail>
                <ins-insurance-regular-driver-form
                    *ngSwitchCase="selectedPanelEnum.InsuranceRegularDriver"
                    [purchasedProduct]="purchasedProduct"
                    [relation]="relation"
                ></ins-insurance-regular-driver-form>
                <ins-insurance-coverage-form
                    *ngSwitchCase="selectedPanelEnum.InsuranceCoverage"
                    [purchasedProduct]="purchasedProduct"
                    [relation]="relation"
                ></ins-insurance-coverage-form>
                <ins-insurance-imic
                    *ngSwitchCase="selectedPanelEnum.InternationalMotorInsuranceCard"
                    [purchasedProduct]="purchasedProduct"
                ></ins-insurance-imic>
                <ins-insurance-imic-buttons
                    *ngSwitchCase="selectedPanelEnum.InternationalMotorInsuranceCardButtons"
                    [purchasedProduct]="purchasedProduct"
                ></ins-insurance-imic-buttons>
                <ins-insurance-end-product-form
                    e2e="terminate-insurance"
                    *ngSwitchCase="selectedPanelEnum.InsuranceEndProduct"
                    [purchasedProduct]="purchasedProduct"
                ></ins-insurance-end-product-form>
                <ins-insurance-end-date-product-form
                    *ngSwitchCase="selectedPanelEnum.InsuranceEndDateProduct"
                    [purchasedProduct]="purchasedProduct"
                ></ins-insurance-end-date-product-form>
                <ins-insurance-start-date-form
                    *ngSwitchCase="selectedPanelEnum.InsuranceStartDateChange"
                    [purchasedProduct]="purchasedProduct"
                    [startDateType]="startDateTypeEnum.Change"
                ></ins-insurance-start-date-form>
                <ins-insurance-start-date-form
                    *ngSwitchCase="selectedPanelEnum.InsuranceStartDateSet"
                    [purchasedProduct]="purchasedProduct"
                    [startDateType]="startDateTypeEnum.Set"
                ></ins-insurance-start-date-form>
            </ng-container>
        </wuc-balloon>
    </wuc-rack>
</wuc-page-block>
